var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetCache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0091 7.46667H0C0.00013619 5.91639 0.48277 4.4046 1.38094 3.14102C2.27911 1.87744 3.54829 0.924735 5.01239 0.415073C6.47649 -0.0945883 8.06292 -0.135934 9.55157 0.296773C11.0402 0.729481 12.3573 1.61478 13.3201 2.82987V1.71481H14.3292V5.24666H10.7973V4.23756H13.0601C12.4927 3.2563 11.6773 2.44144 10.6958 1.87469C9.71416 1.30793 8.60079 1.0092 7.46732 1.00844C3.90622 1.00844 1.0091 3.90556 1.0091 7.46667ZM13.9255 7.46667C13.9255 11.0277 11.0285 13.9249 7.46732 13.9249C6.33385 13.9242 5.22049 13.6254 4.23889 13.0587C3.25728 12.4919 2.44192 11.677 1.87457 10.6958H4.1373V9.68668H0.605458V13.2186H1.61456V12.1035C2.57732 13.3185 3.89441 14.2038 5.38306 14.6366C6.87172 15.0692 8.45815 15.0279 9.92225 14.5183C11.3863 14.0086 12.6556 13.0559 13.5537 11.7923C14.4518 10.5287 14.9345 9.01694 14.9346 7.46667H13.9255Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetCache);
export default __webpack_public_path__ + "static/media/ResetCache.aade56d3.svg";
export { ForwardRef as ReactComponent };